import { z } from 'zod';
// Whether the legacy OR-report page has been switched off, and where to send visitors instead.
export const offerRequestReportDiscontinuedStatusSchema = z.object({
    discontinued: z.boolean(),
    cockpitUrl: z.string(),
});
